import { React, useState, useEffect } from "react";
import { TableBody, TableCell, TableHead, TableSortLabel } from "@mui/material";
import {
	StyledTable,
	TableWrapper,
	TableButton,
	StyledTableRow,
	StyledCheckbox,
	StyledTablePagination,
	TableToolbar,
} from "../../../components/DataTable/DataTable.styles";
import { Link } from "react-router-dom";
import { getFormattedDate } from "../../../utils/DateUtils";
import Tooltip from "@mui/material/Tooltip";
import { Select, MenuItem } from "@mui/material";
import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
import ConfirmModal from "../../../components/ConfirmModal";
import { Addbutton } from "../Education.styled";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { canPerformAction } from "../../../utils/UserAuth";
import { AiFillCheckCircle } from "react-icons/ai";
import { approveMultipleContent } from "../utils";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";
import { getSessionToken } from "../../../utils/Utils";

/* eslint-disable react/prop-types */ // eslint-disable-next-line no-unused-vars
function EducationTable({
	TableData,
	headCells,
	category,
	getEducationTable,
	dateFilter,
	handleDateFilterChange,
}) {
	const dispatch = useDispatch();
	const [confirmModal, setConfirmModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [selected, setSelected] = useState([]);
	const [approveModal, setApproveModal] = useState(false);

	useEffect(() => {
		setSelected([]);
		setPage(0);
		setOrder("asc");
		setOrderBy("");
	}, [TableData]);

	const deleteMultipleVideos = async () => {
		setLoading(true);
		if (selected.length <= 0) {
			toast.error("unable to delete content(s), please try again later");
			setLoading(false);
			return;
		}
		setConfirmModal(false);
		const Objects = selected.map((item) => {
			const Obj = new Parse.Object("Education");
			Obj.id = item.id;
			return Obj;
		});
		Parse.Object.destroyAll(Objects)
			.then(() => {
				getEducationTable(category);
				toast.success(`${category} content(s) successfully deleted`);
				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
				toast.error(`Error deleting ${category} content(s)`);
				setLoading(false);
			});
	};

	const getVisibleRows = () => {
		function descendingComparator(a, b, orderBy) {
			if (b[orderBy] < a[orderBy]) {
				return -1;
			}
			if (b[orderBy] > a[orderBy]) {
				return 1;
			}
			return 0;
		}

		function getComparator(order, orderBy) {
			return order === "desc"
				? (a, b) => descendingComparator(a, b, orderBy)
				: (a, b) => -descendingComparator(a, b, orderBy);
		}

		// Check if TableData is not an array || TableData is empty
		if (Array.isArray(TableData)) {
			return TableData.slice().sort(getComparator(order, orderBy));
		} else return [];
	};

	const visibleRows = getVisibleRows().slice(
		page * rowsPerPage,
		page * rowsPerPage + rowsPerPage
	);

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleClick = (e, id) => {
		const selectedRow = TableData.find((row) => row.id === id);
		const selectedIndex = selected.findIndex(
			(row) => row.id === selectedRow.id
		);

		if (selectedIndex === -1) {
			setSelected((prevSelected) => [...prevSelected, selectedRow]);
		} else {
			setSelected((prevSelected) => [
				...prevSelected.slice(0, selectedIndex),
				...prevSelected.slice(selectedIndex + 1),
			]);
		}
	};

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const newSelected = TableData.map((row) => row);
			setSelected(newSelected);
			return;
		}
		setSelected([]);
	};

	const handleChangePage = (e, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (e) => {
		setRowsPerPage(+e.target.value);
		setPage(0);
	};

		//approve product //handle approval
		const handleApproval = async () => {
			dispatch(setLoadingState(true));
			if (selected.length <= 0) {
				toast.error("content not found!");
				dispatch(setLoadingState(false));
				return;
			}
			setApproveModal(false);
			const selectedIds = selected.map((content) => {
				return content.id;
			});
			// console.log(selectedIds);
			let data = await approveMultipleContent(selectedIds, getSessionToken());
			try {
				if (data.result) {
					dispatch(setLoadingState(false));
					toast.success("Content(s) status updated successfully!");
					getEducationTable(category); //get updated table data
				} else {
					dispatch(setLoadingState(false));
					console.log(data);
					toast.error("unable to approve content(s), please try again later");
				}
			} catch (error) {
				dispatch(setLoadingState(false));
				console.log(error);
				toast.error("unable to approve croduct(s), please try again later");
			}
		};
	

	return (
		<>
			<TableToolbar display='flex'>
				<div className='_buttons'>
					<Link to={`/education/add${category}`}>
						<Addbutton>
							<HiOutlineDocumentAdd size={24} />
							Add {category} Content
						</Addbutton>
					</Link>

					{canPerformAction("edit", "education") && (
						<Tooltip title='Approve' arrow>
							<TableButton
								onClick={()=>setApproveModal(true)}
								display='flex'
								variant='outlined'
								color='primary'
								disabled={selected.length <= 0}
							>
								<AiFillCheckCircle size={24} />
								<p>Approve content</p>
							</TableButton>
						</Tooltip>
					)}
					<Select
						value={dateFilter}
						className='toolbarSelect'
						onChange={(e) => handleDateFilterChange(e)}
					>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					{canPerformAction("delete", "education") && (
						<Tooltip title='Delete' arrow>
							<TableButton
								onClick={() => {
									setConfirmModal(true);
								}}
								variant='outlined'
								color='error'
							>
								<img src={DeleteIcon} alt='' />
							</TableButton>
						</Tooltip>
					)}
				</div>
			</TableToolbar>
			<TableWrapper>
				{confirmModal && (
					<ConfirmModal
						confirmModal={confirmModal}
						setConfirmModal={setConfirmModal}
						content={{
							title: "Delete content(s)",
							desc: "Are you sure you want to Delete these content(s)?",
							btnText: "Yes, Delete",
						}}
						handleDeleteAction={deleteMultipleVideos}
					/>
				)}
				{approveModal && (
					<ConfirmModal
						confirmModal={approveModal}
						setConfirmModal={setApproveModal}
						content={{
							title: "Approve Content",
							desc: "Are you sure you want to approve these content(s)?",
							btnText: "Yes, Approve",
						}}
						handleDeleteAction={handleApproval}
					/>
				)}

				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
						// onClick={() => setLoading(false)}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
				<StyledTable sx={{ minWidth: 650 }}>
					<TableHead>
						<StyledTableRow>
							<TableCell padding='checkbox'>
								<StyledCheckbox
									color='default'
									checked={
										selected.length === TableData.length &&
										TableData.length !== 0
									}
									onChange={(e) => handleSelectAll(e)}
									inputProps={{ "aria-labelledby": "Select All" }}
								/>
							</TableCell>

							{headCells.map((headerCell) => (
								<TableCell
									key={headerCell.field}
									align='left'
									sx={{ minWidth: headerCell.width }}
								>
									<TableSortLabel
										active={orderBy === headerCell.field}
										onClick={() => handleRequestSort(headerCell.field)}
										direction={orderBy === headerCell.field ? order : "asc"}
									>
										{headerCell.title}
									</TableSortLabel>
								</TableCell>
							))}
						</StyledTableRow>
					</TableHead>

					<DataTableBody
						selected={selected}
						visibleRows={visibleRows}
						handleClick={handleClick}
						headCells={headCells}
					/>
				</StyledTable>
			</TableWrapper>

			<StyledTablePagination
				rowsPerPageOptions={[10, 20, 25, 100]}
				component='div'
				count={TableData.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</>
	);
}

const DataTableBody = ({ selected, visibleRows, handleClick, headCells }) => {
	const isSelected = (id) => selected.findIndex((row) => row.id === id) !== -1;

	const TableRowItem = ({ row, headerCell }) => {
		// console.log(row);

		if (headerCell.title === "ACTION") {
			return (
				<TableButton
					component={Link}
					variant='outlined'
					size='small'
					to={`./${row.id}`}
					// to={`./${row.objectId}`}
				>
					View
				</TableButton>
			);
		}

		if (headerCell.field === "approve") {
			const status = row[headerCell.field] ? row[headerCell.field] : false;

			switch (status) {
				case true:
					return <span className='badge approved'>Approved</span>;
				case false:
					return <span className='badge pending'>Pending</span>;
				default:
					return <span className='badge pending'>Pending</span>;
			}
		}

		if (headerCell.field === "createdAt") {
			return (
				<span className={headerCell.field}>
					{getFormattedDate(row["createdAt"])}
				</span>
			);
		}

		if (headerCell.field === "coverPhoto") {
			return (
				<div className='img_container'>
					<img
						style={{
							height: "80px",
							width: "120px",
							objectFit: "cover",
							borderRadius: "5px",
						}}
						className=''
						src={row.coverPhoto}
						alt='content image'
					/>
				</div>
			);
		}

		return (
			<span className={headerCell.field}>
				{row[headerCell.field] ? row[headerCell.field] : "---"}
			</span>
		);
	};

	return (
		<TableBody>
			{visibleRows.map((row) => {
				const isItemSelected = isSelected(row.id);
				return (
					<StyledTableRow
						hover
						key={row.id}
						onClick={(e) => handleClick(e, row.id)}
						role='checkbox'
						selected={isItemSelected}
					>
						<TableCell padding='checkbox'>
							<StyledCheckbox
								color='default'
								checked={isItemSelected}
								inputProps={{ "aria-labelledby": row.id }}
							/>
						</TableCell>

						{headCells.map((headerCell) => (
							<TableCell key={headerCell.field} align='left'>
								<TableRowItem row={row} headerCell={headerCell} />
							</TableCell>
						))}
					</StyledTableRow>
				);
			})}

			{visibleRows.length === 0 && (
				<StyledTableRow>
					<TableCell
						colSpan={headCells.length + 1}
						align='center'
						className='no_data_found'
					>
						NO DATA FOUND
					</TableCell>
				</StyledTableRow>
			)}
		</TableBody>
	);
};

export default EducationTable;
